import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IvfDonorMstApi } from '../api/ivfDonorMst.api';
import { switchMap, map } from 'rxjs/operators';

import { IvfDonorMstData, IvfDonorMst } from '../../../interfaces/masters/ivfdonormst' ;
@Injectable()
export class IvfDonorMstService extends IvfDonorMstData {

    constructor(private api: IvfDonorMstApi) {
      super();
    }  
  
    list(url: string): Observable<IvfDonorMst[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<IvfDonorMst>{
        return this.api.getById(url);
    }
  
    create(url: string, data:IvfDonorMst): Observable<IvfDonorMst[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:IvfDonorMst): Observable<IvfDonorMst> {
      return this.api.update(url,data);
    }
      
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  